const dndUtils = {
  reorder<T>(list: T[], startIndex, endIndex): T[] {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  },
}

export default dndUtils
